export default __webpack_public_path__ + "static/media/nexity-regulations-pl.eca8831b.pdf";